import { Mutation } from 'react-apollo'
import changePasswordByToken, {
  ChangePasswordByToken,
  ChangePasswordByTokenInput
} from '../../graphql/mutations/changePasswordByToken'
import withMutation from './withMutation'

class ChangePasswordByTokenMutation extends Mutation<
  ChangePasswordByToken,
  ChangePasswordByTokenInput
> {}

export default withMutation(changePasswordByToken)(
  ChangePasswordByTokenMutation
)



// WEBPACK FOOTER //
// ./src/components/mutations/ChangePasswordByTokenMutation.tsx